/* eslint-disable no-unused-vars */
import * as mm from '../../services/memberManagement';

export default {
  namespace: 'dgmp',

  state: {
    getDecisionGraphMap: null,
    checkDiagram: null,
    saveDiagram: null,
    queryNodeBlock: null,
    queryCombineRelation: null,
  },

  effects: {
    // 获取决策图管理charts图
    *getDecisionGraphMap({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(mm.getDecisionGraphMap, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          getDecisionGraphMap: response,
        },
      });
    },

    // 决策图管理charts图试运行
    *checkDiagram({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(mm.checkDiagram, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          checkDiagram: response,
        },
      });
    },

    // 决策图管理charts图保存
    *saveDiagram({ payload: { diagramId, values }, callback }, { call, put }) {
      const { data: response } = yield call(mm.saveDiagram, diagramId, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          saveDiagram: response,
        },
      });
    },

    // 获取所有配置过的规则包/模型包数据
    *queryNodeBlock({ payload: {}, callback }, { call, put }) {
      const { data: response } = yield call(mm.queryNodeBlock);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          queryNodeBlock: response,
        },
      });
    },

    // combine relation 组合关系
    *queryCombineRelation({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(mm.queryCombineRelation, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          queryCombineRelation: response,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
